<template>
<div class="chapter">
<div class="inner_page">
<p class="ind" id="epigraph" style="margin-top:20px;"><a id="page15"><i>A scientific discovery is never the work of a single person. Each of those who collaborated in it has contributed many sleepless nights.</i></a></p><a id="page15">
<p class="right">—<span class="small">LOUIS PASTEUR</span>,<br/>French chemist and bacteriologist</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 6-epigraph.vue?1f03024b